import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
@Component({
  selector: 'app-installation-questions',
  standalone: true,
  imports: [CommonModule, AccordionModule],
  templateUrl: './installation-questions.component.html',
  styleUrl: './installation-questions.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class InstallationQuestionsComponent {
  installationQuestions = {
    background: '/images/questions/1.png', // Background image
    title: 'Installation Questions',
    description:
      'Stay connected with reliable internet from Cladded Glass Broadband.',
    faqs: [
      {
        question: '1. How long does installation usually take?',
        answer:
          'The installation process typically takes a few hours, depending on the complexity of the setup once we have fiber available to your home.',
      },
      {
        question: '2. Do I need to be home during the installation?',
        answer:
          'Yes, someone 18 or older needs to be present to provide access to the necessary areas for installation.',
      },
      {
        question: '3. Will the installation cause any damage to my property?',
        answer:
          'We utilize plowing to bury our home drop cables, which causes the least amount of damage. We take a lot of care in our work to leave the area looking the best it can be.',
      },
      {
        question: '4. Do I need special equipment for fiber broadband?',
        answer:
          'No, we provide the hardware needed to convert from fiber to an ethernet cable. We recommend a modern router, but you can use your existing one.',
      },
      {
        question: '5. Is there an installation fee?',
        answer:
          'Yes, Our standard install fee is $499. Our installation fee represents immediate direct costs we incur in providing fiber to your home.',
      },
    ],
  };
}
